import { render, staticRenderFns } from "./cooperativeCourseLibrary.vue?vue&type=template&id=27649d35"
import script from "./cooperativeCourseLibrary.vue?vue&type=script&lang=js"
export * from "./cooperativeCourseLibrary.vue?vue&type=script&lang=js"
import style0 from "./cooperativeCourseLibrary.vue?vue&type=style&index=0&id=27649d35&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports